export enum CheckoutType {
  WALK_IN = 'WALK_IN',
  NEW_TAB = 'NEW_TAB',
  EXISTING_TAB = 'EXISTING_TAB',
  OVERHEAD = 'OVERHEAD',
}
